import React from 'react'
import { motion } from 'framer-motion'
import { ArrowRight, ChevronRight } from 'lucide-react'
import { useNavigate, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import ServiceCTA from '../components/ServiceCTA'

const ServiceHubPage = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const services = [
        {
            title: t('serviceHub.services.bioinformatics.title'),
            desc: t('serviceHub.services.bioinformatics.desc'),
            path: '/service/bioinformatics', icon: '🧬',
            modules: t('serviceHub.services.bioinformatics.modules', { returnObjects: true }),
        },
        {
            title: t('serviceHub.services.aiMl.title'),
            desc: t('serviceHub.services.aiMl.desc'),
            path: '/service/ai-ml', icon: '🤖',
            modules: t('serviceHub.services.aiMl.modules', { returnObjects: true }),
        },
        {
            title: t('serviceHub.services.consultancy.title'),
            desc: t('serviceHub.services.consultancy.desc'),
            path: '/service/consultancy', icon: '🔬',
            modules: t('serviceHub.services.consultancy.modules', { returnObjects: true }),
        },
        {
            title: t('serviceHub.services.writing.title'),
            desc: t('serviceHub.services.writing.desc'),
            path: '/service/scientific-writing', icon: '📝',
            modules: t('serviceHub.services.writing.modules', { returnObjects: true }),
        },
    ]

    return (
        <div className="pt-24 sm:pt-32 pb-24 px-4 sm:px-6 overflow-x-hidden">
            <div className="max-w-5xl mx-auto">
                <nav className="flex items-center gap-1.5 text-xs mb-8 flex-wrap" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                    <Link to="/" className="text-text-dim hover:text-primary transition-colors">{t('header.home')}</Link>
                    <ChevronRight className="w-3 h-3 text-text-dim/40" />
                    <span className="text-text-main font-medium">{t('header.service', 'Services')}</span>
                </nav>
                <motion.div className="text-center mb-12 sm:mb-16">
                    <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-display font-bold tracking-tight text-text-main">
                        {t('serviceHub.title.part1')} <span className="text-gradient-green">{t('serviceHub.title.part2')}</span>
                    </h1>
                    <p className="mt-4 text-text-muted text-base sm:text-lg max-w-2xl mx-auto">{t('serviceHub.desc')}</p>
                </motion.div>

                <div className="space-y-6">
                    {services.map((service, i) => (
                        <motion.button key={i} onClick={() => navigate(service.path)}
                            className="bio-card w-full p-5 sm:p-8 text-left group">
                            <div className="flex items-start justify-between gap-4 sm:gap-6">
                                <div className="flex-1 min-w-0">
                                    <h3 className="text-xl sm:text-2xl font-display font-bold mb-3 text-text-main group-hover:text-primary transition-colors break-words"><span className="mr-2">{service.icon}</span>{service.title}</h3>
                                    <p className="text-text-muted text-sm leading-relaxed mb-5">{service.desc}</p>
                                    <div className="flex flex-wrap gap-2">
                                        {Array.isArray(service.modules) && service.modules.map((mod, j) => <span key={j} className="tag-pill">{mod}</span>)}
                                    </div>
                                </div>
                                <ArrowRight className="w-5 h-5 text-text-dim group-hover:text-primary group-hover:translate-x-1 transition-all flex-shrink-0 mt-2" />
                            </div>
                        </motion.button>
                    ))}
                </div>

                <div className="mt-10 pt-8 border-t border-border-light/50" style={{ marginTop: '40px' }}>
                    <div className="text-center mb-6">
                        <h3 className="text-lg font-display font-bold text-text-main mb-2">{t('serviceHub.cta.title')}</h3>
                        <p className="text-sm text-text-muted">{t('serviceHub.cta.desc')}</p>
                    </div>
                    <div className="flex flex-wrap justify-center gap-6 text-sm font-medium">
                        <Link to="/service-process" className="text-primary hover:text-primary-dark transition-colors">{t('serviceHub.cta.serviceProcess')}</Link>
                        <span className="text-text-dim">|</span>
                        <Link to="/service/data-security" className="text-primary hover:text-primary-dark transition-colors">{t('serviceHub.cta.dataSecurity')}</Link>
                        <span className="text-text-dim">|</span>
                        <Link to="/contact" className="text-primary hover:text-primary-dark transition-colors">{t('serviceHub.cta.contactUs')}</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ServiceHubPage
